// extracted by mini-css-extract-plugin
export default {"comments":"styles_comments__CjATL","single":"styles_single__VxUT5"};